import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dateFormat',
})
export class DateFormatPipe implements PipeTransform {
  transform(value: unknown, dateFormat?: string): unknown {
    const today = moment().startOf('day');
    const date = moment(value, 'DD-MM-YYYY HH:mm:ss.SSSZZ');
    const format = dateFormat
      ? dateFormat
      : date.isSame(today, 'day')
      ? 'HH:mm'
      : date.isSame(today, 'year')
      ? 'MMM D, HH:mm'
      : 'DD-MM-YYYY';
    return moment(value, 'DD-MM-YYYY HH:mm:ss.SSSZZ').format(format);
  }
}
